<template>
  <main class="main">
    <div id="recaptcha-container"></div>
    <v-container id="container">
      <div class="login" id="login-login">
        <div class="login-banner">
          <img src="@/assets/images/login-snap.svg" alt="" />
          <div class="login-content">
            <v-row>
              <v-col data-aos="fade-up">
                <div
                  v-text="'Welcome to RouteLine!'"
                  class="text-h5 text-light font-weight-bold"
                ></div>
                <div
                  v-text="'Please login using your phone number.'"
                  class="text-subtitle-1 text-light"
                ></div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="login-form" id="login-form">
          <div class="form" data-aos="fade-up">
            <div
              v-text="otpShow ? 'Create Account / Sign-in' : 'Enter OTP'"
              class="text-h4 text-secondary font-weight-bold mb-3"
            ></div>
            <form @submit.prevent="handleLogin" v-if="otpShow">
              <v-text-field
                outlined
                rounded
                label="Phone number"
                prepend-inner-icon="mdi-account"
                v-model="phoneNumber"
                type="tel"
                id="phone-number"
              >
              </v-text-field>

              <!-- show related message -->
              <div v-if="showError" class="text-danger mb-3">
                <v-icon left style="color: #ff0000">mdi-alert-circle</v-icon>
                <span style="color: #ff0000">
                  This membership has been cancelled, please (Contact – <a style="color: #ff0000" target="_blank" href="https://routeline.com/pages/contact">Route Line Co.</a>) for assistance.
                </span>
              </div>


              <v-btn
                color="primary"
                block
                large
                rounded
                type="submit"
                :loading="loadingPhone"
                id="phone-enter"
              >
                SEND ONE-TIME PASSWORD
              </v-btn>
            </form>
            <form @submit.prevent="handleLogin" id="form" v-else>
              <div style="margin-bottom: 15px">
                <otp-input
                  @on-complete="verifyOtp"
                  :num-inputs="6"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  input-classes="otp-input"
                  separator=""
                  @on-change="value => otp = value"
                  ref="otpInput"
                  id="otp-add"
                >
                </otp-input>
              </div>

              <v-btn
                color="primary"
                block
                large
                rounded
                type="submit"
                :loading="loadingVerify"
                id="otp-resend"
              >
                RESEND OTP
              </v-btn>
            </form>
          </div>
        </div>
      </div>
    </v-container>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/compat/app";
// import { dbFs } from "../../modules/database";
import axios from "../../modules/axios";

export default {
  name: "Login",
  data: () => ({
    phoneNumber: "",
    captchaVerifier: null,
    country: "+1",
    otpShow: true,
    loadingPhone: false,
    loadingVerify: false,
    otp: "",
    showError: false,
  }),
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  created() {
    this.initReCaptcha();
  },
  mounted() {
    this.checkLogin();
  },
  methods: {
    async handleLogin() {
      try {

        this.$refs.otpInput?.clearInput();
      } catch (error) {
        // console.log(error);
      }
      // validate a valid phone number
      if (!this.phoneNumber.match(/^\+?[0-9]{10,15}$/)) {
        this.$root.toast("Invalid phone number", "error");
        return;
      }
      
      if (this.phoneNumber.length !== 10) {
        this.$root.toast("Invalid Phone Number", "error");
        return;
      }
      try {
        this.loadingPhone = true;

        const isAlreadyUser = await this.checkUserAvailable(
          this.country + this.phoneNumber
        );

        if (!isAlreadyUser) {
          this.$root.toast("You are not registered with us.", "warning");
          this.$router.push("/signup?phone=" + this.phoneNumber);
          return;
        }
        if ( isAlreadyUser?.status !== "active" ) {
          this.showError = true;
          setTimeout(() => {
            this.showError = false;
          }, 5000);
          return;
        }

        window.confirmationResult = await firebase
          .auth()
          .signInWithPhoneNumber(
            this.country + this.phoneNumber,
            this.captchaVerifier
          );
        // this.$snackbar(' OTP sent successfully', 'success')
        this.otpShow = false;
      } catch (e) {
        this.$root.toast(e.message?.replace("Firebase:", ""), 'error')
        console.log(e);
        this.loadingPhone = false;
      } finally {
        this.loadingPhone = false;
      }
    },
    async verifyOtp() {
      this.loadingVerify = true;
      try {
        const user = await window.confirmationResult.confirm(this.otp);
        if (user) {
          // this.$root.toast("Welcome back!", "success");
          if (this.$route.query.redirect) {
            const { start, end } = this.$route.query;
            this.$router.push(
              `${this.$route.query.redirect}?start=${start}&end=${end}`
            );
          } else {
            this.$router.push("/");
          }
        }
      } catch (e) {
        this.$root.toast("OTP NOT MATCHED", "error");
      } finally {
        this.loadingVerify = false;
      }
    },
    initReCaptcha() {
      setTimeout(() => {
        // disable captcha fro testing
        if ( firebase.app().options.projectId === "routeline-dev" ) {
          firebase.auth().settings.appVerificationDisabledForTesting = true;
        }
        
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          "recaptcha-container",
          {
            size: "invisible",
            callback() {},
            "expired-callback"() {},
          }
        );
        this.captchaVerifier = window.recaptchaVerifier;
      }, 1000);
    },
    checkLogin() {
      if (this.user) {
        this.$router.push("/");
      }
    },
    async checkUserAvailable(phoneNumber) {
      try {
        const response = await axios.get(`/check-user/${phoneNumber}`);
        if (response.data?.uid) {
          return response.data;
        }

        return false;
      } catch (error) {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  max-width: 300px;
}
.login {
  display: flex;
  border: 1px solid #e0e0e0;
  border-radius: 15px;

  &-banner {
    position: relative;
    height: 100%;
  }

  &-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding: 20px;
    background: var(--light);
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.main {
  position: relative;
  height: 100vh;
  width: 100%;
  // background: rgba(111, 115, 3, 0.15);
  opacity: 1;
  display: flex;
  align-items: center;
}
.logo {
  // width: 100%;
  height: 50px;
}
.card-login {
  padding: 30px;
}

@media screen and (max-width: 1200px) {
  .login {
    max-width: 100%;

    &-banner {
      display: none;
    }
    &-form {
      height: 70vh;
    }
  }
}
</style>

<style>
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 5px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgb(0, 0, 0);
  text-align: center;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>